import React from 'react';
import { UnitConverter } from './UnitConverter';

const units = [
  { key: 'kip',     label: 'Kip' },
  { key: 'kg',      label: 'Kilograms' },
  { key: 'mt',      label: 'Metric tons' },
  { key: 'pound',   label: 'Pounds' },
  { key: 'ton',     label: 'Tons (US)' },
  { key: 'ounce',   label: 'Ounces' },
  { key: 'tola',    label: 'Tola' },
  { key: 'gm',      label: 'Grams' },
  { key: 'seer',    label: 'Seer' },
  { key: 'knewton', label: 'Kilo Newton' },
  { key: 'quint',   label: 'Quintal' },
  { key: 'newton',  label: 'Newton' },
];

// Base: kip
const factors = {
  kip:     1,
  kg:      453.59237,
  mt:      0.4563,
  pound:   1000,
  ton:     0.5,
  ounce:   16000,
  tola:    38888.85,
  gm:      453592.37,
  seer:    486.11074852241,
  knewton: 4.4482216,
  quint:   4.54,
  newton:  4448.2216,
};

export const ConvWeight = () => (
  <UnitConverter
    title="Weight"
    units={units}
    factors={factors}
    explanationTitle="Units of weight"
    explanation="1 lb = 0.4536 kg. The English system's pound is approximately 0.454 times a kilogram in the metric system."
  />
);
